const LOWERCASE_WORDS = new Set(["of", "and", "the"]);

function titleCaseWord(word) {
  if (!word) return word;
  return word[0].toUpperCase() + word.slice(1).toLowerCase();
}

export function titleCaseLocationSlug(slug) {
  if (!slug) return "";
  return slug
    .split("_")
    .map((token, idx) =>
      token
        .split("-")
        .map((part) =>
          idx !== 0 && LOWERCASE_WORDS.has(part.toLowerCase())
            ? part.toLowerCase()
            : titleCaseWord(part)
        )
        .join("-")
    )
    .join(" ");
}

// Mirror of server-side `citySlug` in services/cityDiscoveryService.js.
// "New Haven" → "new_haven", "Washington, DC" → "washington_dc"
export function citySlug(text) {
  if (!text) return "";
  return text
    .toLowerCase()
    .replace(/[,]/g, "")
    .replace(/\s+/g, "_")
    .replace(/[^\w_-]/g, "")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
}
